// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O_Zxg","right":"styles_right__1NhwU"};